// how to use the button component
//      <Button
//        defaultClick={function_called}
//        styleName={"button button--primary"}
//        text={"Export Table to CSV File"}
//        id={"export_csv"}
//      />


const Button = (props) => {
  const defaultClick = (e) => {
    if (props.onClick === undefined || props.onClick === null) {

    } else {

      props.onClick(e);
    }
  };

  // default text on button if no input found
  const button_text = "button";

  return (
    <button
      className={props.styleName}
      onClick={defaultClick}
      id={props.id}
      disabled={props.isDisabled}
    >
      {props.text !== undefined ? props.text : button_text}
    </button>
  );
};

export default Button;
